import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
const containerStyles = css `
  display: inline-block;
  position: relative;
`;
export const positions = {
    bottomLeft: 'bottomLeft',
    bottomRight: 'bottomRight',
    topLeft: 'topLeft',
    topRight: 'topRight',
};
const defaultProps = {
    horizontalOffset: 50,
    position: positions.bottomRight,
    verticalOffset: 50,
};
const Positioner = ({ badge, children, position = defaultProps.position, horizontalOffset = defaultProps.horizontalOffset, verticalOffset = defaultProps.verticalOffset, }) => {
    const badgeContainerStyles = useMemo(() => (css `
        position: absolute;

        ${position === 'bottomLeft' && css `
          bottom: 0;
          left: 0;
          transform: translate(-${horizontalOffset}%, ${verticalOffset}%);
        `}
        ${position === 'bottomRight' && css `
          bottom: 0;
          right: 0;
          transform: translate(${horizontalOffset}%, ${verticalOffset}%);
        `}
        ${position === 'topLeft' && css `
          left: 0;
          top: 0;
          transform: translate(-${horizontalOffset}%, -${verticalOffset}%);
        `}
        ${position === 'topRight' && css `
          right: 0;
          top: 0;
          transform: translate(${horizontalOffset}%, -${verticalOffset}%);
        `}
      `), [
        horizontalOffset,
        position,
        verticalOffset,
    ]);
    return (_jsx("div", { children: _jsxs("div", Object.assign({ css: containerStyles }, { children: [_jsx("div", Object.assign({ css: badgeContainerStyles }, { children: badge })), children] })) }));
};
const OffsetMemoizedPosition = memo(Positioner);
export { OffsetMemoizedPosition as Positioner };
// MC-1068 Temporary hack for Storybook.
export default Positioner;
